module.exports = __webpack_public_path__ + "img/clock.0b8c770d.png";